var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FF6843"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.4923V17.3608C6 17.7956 6.15804 18.2125 6.43934 18.5199C6.72064 18.8273 7.10218 19 7.5 19H16.5C16.8978 19 17.2794 18.8273 17.5607 18.5199C17.842 18.2125 18 17.7956 18 17.3608V14.4923M12.0007 5L12.0007 14.2886M12.0007 14.2886L8.57213 10.7395M12.0007 14.2886L15.4293 10.7395",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDownload);
export default __webpack_public_path__ + "static/media/AudioDownload.471b898e552c97792f20579077ffd127.svg";
export { ForwardRef as ReactComponent };